import * as React from 'react';

import { useReactFlow } from '@xyflow/react';
import type { Edge } from '@xyflow/react';

import { getLayoutedElements, type LayoutConfig } from '../layout/elkLayout';
import type { AutomationNode } from '../nodes/types';

export function useAutoLayout(
  setNodes: (nodes: AutomationNode[]) => void,
  _setEdges: (edges: Edge[]) => void,
) {
  const [isLayouting, setIsLayouting] = React.useState(false);
  const { getNodes, getEdges, fitView } = useReactFlow();

  const applyLayout = React.useCallback(
    async (config?: Partial<LayoutConfig>) => {
      setIsLayouting(true);
      try {
        const nodes = getNodes() as AutomationNode[];
        const edges = getEdges();

        const { nodes: layoutedNodes } = await getLayoutedElements(
          nodes,
          edges,
          config,
        );

        setNodes(layoutedNodes);

        // Fit view with animation
        window.requestAnimationFrame(() => {
          fitView({ padding: 0.2, duration: 300 });
        });
      } finally {
        setIsLayouting(false);
      }
    },
    [getNodes, getEdges, setNodes, fitView],
  );

  return { applyLayout, isLayouting };
}
